import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainRoutes from "./routes";
import App from "./App";
import "tw-elements";
import "bootstrap/dist/css/bootstrap.min.css";
import Providers from "./context/Provider";
import React from "react";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Providers>
      <Router>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/*" element={<MainRoutes />} />
        </Routes>
      </Router>
    </Providers>
  </React.StrictMode>
);

reportWebVitals();

